module.exports = __webpack_public_path__ + "static/img/shiyi.f661292.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/shiyi.png
// module id = mM+s
// module chunks = 1